import type { ApiCommand, ApiRequest } from './apiCommand';
import type { IngestStorageConfigClientDto } from '../dto/ingestStorageConfigDto';
import type { MinioConfigDto, CreateMinioConfigDto } from '../dto/keldaConfigPrimitives';
import { assumeArray, assumeObject } from '../type-guards/assumeType';

type UploadLocationList = (IngestStorageConfigClientDto | MinioConfigDto)[];

export class ListUploadLocationsCommand implements ApiCommand<UploadLocationList> {
  constructor(input: Record<string, never>) {
    void input;
  }
  request(): ApiRequest {
    return {
      linkName: 'tenantConfigUploadLocations',
      pathParams: {},
      queryParams: {},
      method: 'GET',
      body: null
    };
  }
  asOutput(body: unknown): UploadLocationList {
    return assumeArray<any>(body) as UploadLocationList;
  }
}

export class CreateLocationCommand implements ApiCommand<MinioConfigDto> {
  constructor(private input: { keldaConfigId?: string | undefined, config: CreateMinioConfigDto }) {
  }
  request(): ApiRequest {
    const queryParams: Record<string, string> = {};
    if (this.input.keldaConfigId) {
      queryParams.keldaConfigId = this.input.keldaConfigId;
    }
    return {
      linkName: 'configs',
      pathParams: {
        type: 'location',
      },
      queryParams,
      method: 'POST',
      body: this.input.config
    };
  }
  asOutput(body: unknown): MinioConfigDto {
    return assumeObject<MinioConfigDto>(body, 'bucketName');
  }
}

export class DeleteLocationCommand implements ApiCommand<void> {
  constructor(private input: { configId: string }) {
  }
  request(): ApiRequest {
    return {
      linkName: 'config',
      pathParams: {
        type: 'location',
        configId: this.input.configId
      },
      queryParams: {},
      method: 'DELETE',
      body: null
    };
  }
  asOutput(body: unknown): void {
  }
}
